import axios from "axios";

export default function OfferStartProjectService(offerId) {
  return axios({
    method: 'POST',
    url: process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/startProject",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
